export class DashboardTimestamp {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isDefaultLoaded: boolean;
}
